import useAuth from '../../features/auth/useAuth';
import TabItem from './TabItem';
import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import { getModalsState, modalsActions } from '../../features/modals/modalsSlice';
import { ReactComponent as DownArrowGrey } from '../../images/down-arrow-grey.svg';
import './styles/tabContainer.scss';
import { appManagerActions } from '../../store/appManager/actions';
import { useEffect, useState } from 'react';

interface TabContainerProps {
  tabArray: { index: number; name: string; onlyAdmin?: boolean }[];
  type: string;
}

const TabContainer = ({ tabArray, type }: TabContainerProps) => {
  const { userMobileTabs } = useAppSelector(getModalsState);
  const { isManager } = useAuth({});
  const [keyName, setKeyName] = useState<string>('');
  const dispatch = useAppDispatch();

  const handleMenuClick = () => {
    userMobileTabs
      ? dispatch(modalsActions.userMobileTabs(false))
      : dispatch(modalsActions.userMobileTabs(true));
  };

  useEffect(() => {
    switch (type) {
      case 'assistance':
        setKeyName('selectedAssistanceTab');
        break;
      case 'adDetailsForms':
        setKeyName('selectedAdDetailsFormTab');
        break;
      default:
        setKeyName('selectedAccountTab');
    }
  }, [type]);

  const handleClick = (index: number) => {
    if (type === 'account') {
      dispatch((appManagerActions as any)[keyName].set(index));
      dispatch(modalsActions.profileMenu(false));
    } else {
      dispatch((appManagerActions as any)[keyName].set(index));
    }
  };

  return (
    <div className="tabs">
      <ul className="tabs-list">
        {tabArray
          .filter((elmt) => (isManager ? true : !elmt.onlyAdmin))
          .map((elmt) => (
            <TabItem key={elmt.index} index={elmt.index} type={type}>
              {elmt.name}
            </TabItem>
          ))}
      </ul>
      <div onClick={handleMenuClick} className="tabs-arrow">
        <DownArrowGrey />
      </div>
      {userMobileTabs && (
        <div className="tabs-menu">
          <ul className="tabs">
            {tabArray
              .filter((elmt) => (isManager ? true : !elmt.onlyAdmin))
              .map((elmt) => (
                <li
                  key={elmt.index}
                  className="tabs-elt"
                  onClick={() => handleClick(elmt.index)}
                >
                  {elmt.name}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TabContainer;
